import { FeatureFlagKey } from 'src/DTO/Company.type';
import { useApi } from './useApi';
import { BaseRequest, BaseHookRequest } from './useApi.types';
import { ToggleFeatureFlagPayload } from './useCompany.types';

export const useToggleFeatureFlag: BaseHookRequest<null, ToggleFeatureFlagPayload> = params => {
  const [{ postRequest }, state] = useApi<null>(params);
  const toggleFeatureFlag: BaseRequest<ToggleFeatureFlagPayload> = details => {
    return details?.variables
      ? postRequest<ToggleFeatureFlagPayload>('/admin/featureFlag/toggle', {
          ...details.variables,
        })
      : undefined;
  };
  return [toggleFeatureFlag, state];
};

export const useGetFeatureFlags: BaseHookRequest<FeatureFlagKey[], null> = params => {
  const [{ getRequest }, state] = useApi<FeatureFlagKey[]>(params);
  const getFeatureFlags = () => {
    return getRequest('/admin/featureFlag/all');
  };
  return [getFeatureFlags, state];
};
